// Libs
import React from 'react'

// CSS
import "./styles.scss"

const FeatureChat = () => {
  var bubbles = []
  const bubblesCount = 6

  for (var i = 0; i < bubblesCount; i++) {
    bubbles = [...bubbles, 'bubble']
  }

  return (
    <div className="feature-chat">
      {bubbles.map((item, idx) => (
        <div
          key={idx}
          className={(idx % 2 === 0) ? "feature-chat__bubble" : "feature-chat__bubble feature-chat__bubble--light"}
          style={{
            visibility: 'hidden',
            zIndex: idx,
            animationDelay: `-${20 - idx * 2.5}s`
          }}>
          <span className="feature-chat__line" style={{ width: `${(Math.round(Math.random() * 80 + 20))}%` }} />
          <span className="feature-chat__line" style={{ width: `${(Math.round(Math.random() * 80 + 20))}%` }} />
          <span className="feature-chat__line" style={{ width: `${(Math.round(Math.random() * 80 + 20))}%` }} />
          <span className="feature-chat__line" style={{ display: (Math.round(Math.random() * 1)) ? "none" : "", width: `${(Math.round(Math.random() * 80 + 20))}%` }} />
          <span className="feature-chat__line" style={{ display: (Math.round(Math.random() * 1)) ? "none" : "", width: `${(Math.round(Math.random() * 80 + 20))}%` }} />
        </div>
      ))}
    </div>
  )
}

export default FeatureChat
